"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebRenderer = exports.MilStdIconRenderer = exports.RendererUtilities = exports.clsRenderer = exports.PointConverter3D = exports.BasicShapes = exports.MilStdSymbol = exports.ShapeInfo = exports.SymbolID = exports.RendererSettings = exports.SymbolUtilities = exports.SVGSymbolInfo = exports.SVGLookup = exports.SVGInfo = exports.MSInfo = exports.MSLookup = exports.GENCLookup = exports.MODrawRules = exports.DrawRules = exports.Modifiers = exports.MilStdAttributes = exports.ErrorLogger = exports.LogLevel = exports.DistanceUnit = exports.AffiliationColors = exports.Color = exports.Font = exports.Rectangle2D = exports.Point2D = exports.Point = void 0;
exports.initialize = initialize;
exports.init = init;
exports.isReady = isReady;
const ErrorLogger_1 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/ErrorLogger");
const GENCLookup_1 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/GENCLookup");
const MSLookup_1 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/MSLookup");
const SVGLookup_1 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/SVGLookup");
var Point_1 = require("./src/main/ts/armyc2/c5isr/graphics2d/Point");
Object.defineProperty(exports, "Point", { enumerable: true, get: function () { return Point_1.Point; } });
var Point2D_1 = require("./src/main/ts/armyc2/c5isr/graphics2d/Point2D");
Object.defineProperty(exports, "Point2D", { enumerable: true, get: function () { return Point2D_1.Point2D; } });
var Rectangle2D_1 = require("./src/main/ts/armyc2/c5isr/graphics2d/Rectangle2D");
Object.defineProperty(exports, "Rectangle2D", { enumerable: true, get: function () { return Rectangle2D_1.Rectangle2D; } });
var Font_1 = require("./src/main/ts/armyc2/c5isr/graphics2d/Font");
Object.defineProperty(exports, "Font", { enumerable: true, get: function () { return Font_1.Font; } });
var Color_1 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/Color");
Object.defineProperty(exports, "Color", { enumerable: true, get: function () { return Color_1.Color; } });
var AffiliationColors_1 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/AffiliationColors");
Object.defineProperty(exports, "AffiliationColors", { enumerable: true, get: function () { return AffiliationColors_1.AffiliationColors; } });
var DistanceUnit_1 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/DistanceUnit");
Object.defineProperty(exports, "DistanceUnit", { enumerable: true, get: function () { return DistanceUnit_1.DistanceUnit; } });
var LogLevel_1 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/LogLevel");
Object.defineProperty(exports, "LogLevel", { enumerable: true, get: function () { return LogLevel_1.LogLevel; } });
var ErrorLogger_2 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/ErrorLogger");
Object.defineProperty(exports, "ErrorLogger", { enumerable: true, get: function () { return ErrorLogger_2.ErrorLogger; } });
var MilStdAttributes_1 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/MilStdAttributes");
Object.defineProperty(exports, "MilStdAttributes", { enumerable: true, get: function () { return MilStdAttributes_1.MilStdAttributes; } });
var Modifiers_1 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/Modifiers");
Object.defineProperty(exports, "Modifiers", { enumerable: true, get: function () { return Modifiers_1.Modifiers; } });
var DrawRules_1 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/DrawRules");
Object.defineProperty(exports, "DrawRules", { enumerable: true, get: function () { return DrawRules_1.DrawRules; } });
var MODrawRules_1 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/MODrawRules");
Object.defineProperty(exports, "MODrawRules", { enumerable: true, get: function () { return MODrawRules_1.MODrawRules; } });
var GENCLookup_2 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/GENCLookup");
Object.defineProperty(exports, "GENCLookup", { enumerable: true, get: function () { return GENCLookup_2.GENCLookup; } });
var MSLookup_2 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/MSLookup");
Object.defineProperty(exports, "MSLookup", { enumerable: true, get: function () { return MSLookup_2.MSLookup; } });
var MSInfo_1 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/MSInfo");
Object.defineProperty(exports, "MSInfo", { enumerable: true, get: function () { return MSInfo_1.MSInfo; } });
var SVGInfo_1 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/SVGInfo");
Object.defineProperty(exports, "SVGInfo", { enumerable: true, get: function () { return SVGInfo_1.SVGInfo; } });
var SVGLookup_2 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/SVGLookup");
Object.defineProperty(exports, "SVGLookup", { enumerable: true, get: function () { return SVGLookup_2.SVGLookup; } });
var SVGSymbolInfo_1 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/SVGSymbolInfo");
Object.defineProperty(exports, "SVGSymbolInfo", { enumerable: true, get: function () { return SVGSymbolInfo_1.SVGSymbolInfo; } });
var SymbolUtilities_1 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/SymbolUtilities");
Object.defineProperty(exports, "SymbolUtilities", { enumerable: true, get: function () { return SymbolUtilities_1.SymbolUtilities; } });
var RendererSettings_1 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/RendererSettings");
Object.defineProperty(exports, "RendererSettings", { enumerable: true, get: function () { return RendererSettings_1.RendererSettings; } });
var SymbolID_1 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/SymbolID");
Object.defineProperty(exports, "SymbolID", { enumerable: true, get: function () { return SymbolID_1.SymbolID; } });
var ShapeInfo_1 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/ShapeInfo");
Object.defineProperty(exports, "ShapeInfo", { enumerable: true, get: function () { return ShapeInfo_1.ShapeInfo; } });
var MilStdSymbol_1 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/MilStdSymbol");
Object.defineProperty(exports, "MilStdSymbol", { enumerable: true, get: function () { return MilStdSymbol_1.MilStdSymbol; } });
var BasicShapes_1 = require("./src/main/ts/armyc2/c5isr/JavaLineArray/BasicShapes");
Object.defineProperty(exports, "BasicShapes", { enumerable: true, get: function () { return BasicShapes_1.BasicShapes; } });
var PointConverter3D_1 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/PointConverter3D");
Object.defineProperty(exports, "PointConverter3D", { enumerable: true, get: function () { return PointConverter3D_1.PointConverter3D; } });
var clsRenderer_1 = require("./src/main/ts/armyc2/c5isr/RenderMultipoints/clsRenderer");
Object.defineProperty(exports, "clsRenderer", { enumerable: true, get: function () { return clsRenderer_1.clsRenderer; } });
var RendererUtilities_1 = require("./src/main/ts/armyc2/c5isr/renderer/utilities/RendererUtilities");
Object.defineProperty(exports, "RendererUtilities", { enumerable: true, get: function () { return RendererUtilities_1.RendererUtilities; } });
var MilStdIconRenderer_1 = require("./src/main/ts/armyc2/c5isr/renderer/MilStdIconRenderer");
Object.defineProperty(exports, "MilStdIconRenderer", { enumerable: true, get: function () { return MilStdIconRenderer_1.MilStdIconRenderer; } });
var WebRenderer_1 = require("./src/main/ts/armyc2/c5isr/web/render/WebRenderer");
Object.defineProperty(exports, "WebRenderer", { enumerable: true, get: function () { return WebRenderer_1.WebRenderer; } });
/**
 * Module for rendering 2525D/E symbology
 */
let initialized = false;
let initializing = false;
/**
 * Loads files needed by the renderer and initializes its data.
 * Required call before any rendering.
 * Must wait for the returned promise to resolve before any rendering.
 * @param location where renderer and asset files are location.  So if location is "127.0.0.1:8080/dist/C5Ren.js"
 * pass in "/dist/".  This is needed when all the files aren't in the same location.  When the renderer gets imported, it thinks it's
 * in the location of the file that imported it, not where it actually exists and then it can't find the asset files.  If location is not
 * set, the renderer assumes the json asset files are in the same location as where the C5Ren script is being run.
 * Additionally, if your build process hashes the manifest.json file, you should include the new name like "/dist/manifest.[hash].json"
 * @deprecated
 */
async function initialize(location) {
    initializing = true;
    /*
    try
    {
      if(!initialized)
      {
        let promises:Array<Promise<any>> = new Array<Promise<any>>()
        let manifestName:string = 'manifest.json';
        let manifestIndex:number = -1;
  
        //Load data from specific path
        let path:string = "";
        if(location)
        {
          if(location.startsWith('/')==false)
            location = '/' + location;
          manifestIndex = location.indexOf("manifest");
          if(location.endsWith("json") && manifestIndex >= 0)
          {
            manifestName = location.substring(manifestIndex);
            location = location.substring(0,manifestIndex);
          }
          if(location.endsWith('/')==true)
            location = location.substring(0,location.length-1);
          path = location;
        }
          
  
        //load data from path provided in manifest file/////////////////////
        // Fetch Webpack manifest to get the hashed filename
        const manifestResponse = await fetch(location + "/" + manifestName);
        const manifest = await manifestResponse.json();
  
        // Get the hashed JSON file URL
        const gencUrl = path + manifest['data/genc.json'];
        const msdUrl = path + manifest['data/msd.json'];
        const mseUrl = path + manifest['data/mse.json'];
        const svgdUrl = path + manifest['data/svgd.json'];
        const svgeUrl = path + manifest['data/svge.json'];
  
        promises.push(GENCLookup.setData(gencUrl));
        promises.push(MSLookup.setData([msdUrl,mseUrl]));
        promises.push(SVGLookup.setData([svgdUrl,svgeUrl]));
  
        await Promise.all(promises).then(values => {GENCLookup.getInstance();MSLookup.getInstance();SVGLookup.getInstance()}).catch(error => {throw error;});
        initialized=true;
      }
    }
    catch(e)
    {
        throw e;
    }
    finally
    {
      initializing = false;
    }//*/
    initializing = false;
    initialized = true;
}
/**
 *
 * @param location
 * @deprecated
 */
async function init(location) {
    /*initializing = true;
    try
    {
      if(!initialized)
      {
        GENCLookup.setDataObject();//(genc);
        MSLookup.setDataObject();//(msd,mse);
        SVGLookup.setDataObject();//(svgd,svge);
  
        if(GENCLookup.getInstance() && MSLookup.getInstance() && SVGLookup.getInstance())
          initialized=true;
      }
    }
    catch(e)
    {
        throw e;
    }
    finally
    {
      initializing = false;
    }//*/
    initialized = true;
}
/**
 * Returns true if renderer files are loaded and initialized.
 * @returns boolean
 */
function isReady() {
    try {
        if (GENCLookup_1.GENCLookup.getInstance() && MSLookup_1.MSLookup.getInstance() && SVGLookup_1.SVGLookup.getInstance())
            return (GENCLookup_1.GENCLookup.getInstance().isReady() && MSLookup_1.MSLookup.getInstance().isReady() && SVGLookup_1.SVGLookup.getInstance().isReady());
        else
            return false;
    }
    catch (e) {
        ErrorLogger_1.ErrorLogger.LogException("C5Ren", "isReady()", e);
        return false;
    }
}
//# sourceMappingURL=index.js.map